var _circle, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproveToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.668,
    d: "M8.613 13.717c.976.333 2.27.516 3.644.516 1.373 0 2.667-.183 3.643-.516 1.04-.355 1.614-.853 1.614-1.401 0-.55-.573-1.047-1.614-1.402-.976-.332-2.27-.516-3.643-.516-1.374 0-2.668.184-3.644.516C7.573 11.27 7 11.767 7 12.316c0 .549.573 1.046 1.613 1.4z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.668,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.155 14.448a.56.56 0 0 0-.273.086c-.15.084-.339.15-.539.218l-.058.02c-1.092.378-2.523.586-4.028.586-1.506 0-2.936-.208-4.029-.586-.308-.106-.394-.14-.508-.199a.704.704 0 0 0-.322-.091c-.21 0-.339.14-.374.28A.82.82 0 0 0 7 14.96c0 .557.573 1.061 1.613 1.421.976.338 2.27.523 3.644.523 1.373 0 2.667-.185 3.643-.523 1.04-.36 1.614-.864 1.614-1.42a.83.83 0 0 0-.043-.26c-.072-.22-.229-.253-.316-.253z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.668,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.155 17.034a.56.56 0 0 0-.273.085 3.34 3.34 0 0 1-.538.218l-.059.02c-1.092.378-2.523.586-4.028.586-1.506 0-2.936-.208-4.028-.585-.31-.107-.395-.14-.51-.2a.704.704 0 0 0-.32-.091c-.21 0-.34.14-.375.28a.821.821 0 0 0-.024.198c0 .557.573 1.062 1.613 1.421.976.338 2.27.524 3.644.524 1.373 0 2.667-.186 3.643-.524 1.04-.36 1.614-.864 1.614-1.42a.83.83 0 0 0-.043-.26c-.072-.22-.229-.252-.316-.252z",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.798 5.202a.69.69 0 0 0-.974 0l-4.895 5.529-1.753-1.753a.69.69 0 1 0-.974.975l2.24 2.24a.687.687 0 0 0 .975 0l5.381-6.017a.69.69 0 0 0 0-.974z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24,
    y1: 0,
    x2: -0.598,
    y2: 0.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 26.084,
    y1: 14.508,
    x2: 20.084,
    y2: 4.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 26.084,
    y1: 17.081,
    x2: 23.184,
    y2: 9.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 26.084,
    y1: 19.666,
    x2: 22.798,
    y2: 11.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveToken);
export default __webpack_public_path__ + "static/media/approveToken.2cad71d8d9195a19b46041d9fd8fb832.svg";
export { ForwardRef as ReactComponent };